import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../core/_config/app.config';
import {CustomResponse} from '../interfaces/CustomResponse';
@Injectable({
    providedIn: 'root',
})
export class JournalTypeService{
    private API_URL = this.config.urlApi + this.config.versionApi;
    constructor(private http: HttpClient, private config: AppConfig) {}

    getAll(): Observable<any> {
        return this.http.get<CustomResponse<any>>(`${this.API_URL}JournalType/GetAll`);
    }

}
